import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Layout from "src/components/layout/Layout";
import ProfileTabs from "src/components/layout/profile-settings-layout/ProfileTabs";

interface ProfileSettingsLayoutProps extends Translation {
	title: string;
	children?: any;
}

const ProfileSettingsLayout = ({
	t,
	title,
	children,
}: ProfileSettingsLayoutProps) => {
	// const auth = useAuth();
	return (
		<Layout container="xxl" {...{ title }}>
			{/* <Container className="gap-4" variant="xxl"> */}
			<ProfileTabs />
			{children}
			{/* </Container> */}
		</Layout>
	);
};

ProfileSettingsLayout.Tabs = ProfileTabs;

ProfileSettingsLayout.locale = {
	nl: {},
	en: {},
};

export default withTranslation(ProfileSettingsLayout);
